import { render, staticRenderFns } from "./cardBody.vue?vue&type=template&id=55e206b6&lang=true&"
import script from "./cardBody.vue?vue&type=script&lang=js&"
export * from "./cardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e206b6')) {
      api.createRecord('55e206b6', component.options)
    } else {
      api.reload('55e206b6', component.options)
    }
    module.hot.accept("./cardBody.vue?vue&type=template&id=55e206b6&lang=true&", function () {
      api.rerender('55e206b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbon-removal/views/cardBody.vue"
export default component.exports